export default '/build/45fc051a.jpg'